import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'

export const ListCreditCardItem = styled.div`
  padding: 0.625rem 0;
  display: flex;
  justify-content: space-between;
  line-height: 1.5625rem;
  font-size: 1.125rem;
  border-bottom: solid 1px ${color.SILVER};
  transition: background 200ms;
  align-items: center;
  color: ${color.MORTAR};

  ${p =>
    p.isEditable &&
    `
    cursor: pointer;

    &:hover {
      background: ${color.AQUA_OVERLAY};
    }
  `}
`

export const Label = styled.div`
  flex-grow: 1;
`

export const Image = styled.div`
  width: 3rem;
  height: 1.875rem;
`

export const Last4 = styled.span`
  color: ${color.SILVER};
  font-size: 1.0625rem;
  line-height: 1.25rem;
  margin-left: 0.9375rem;
`

export const Icon = styled(BaseIcon)`
  font-size: 1.5625rem;
  color: ${color.AQUAMARINE};
  margin-left: 0.4375rem;
`
